<template>
  <div class="edit-rank-box">
    <el-dialog :title="title" :visible.sync="dialogVisible" width="400px" :before-close="handleClose" :close-on-click-modal="false">
      <el-form ref="form" :model="params" label-width="120px" :inline="true" :rules="rules">
        <el-form-item label="排序:" prop="sortKey">
            <el-input v-model.number="params.sortKey" size="small" placeholder="请输入排序"></el-input>
        </el-form-item>
        <el-form-item label="推荐用户id:" prop="uid">
          <el-input v-model.number="params.uid"  size="small" placeholder="请输入推荐用户id"></el-input>
        </el-form-item>
        <el-form-item label="状态:" prop="active">
          <el-switch v-model="params.active"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" size="small" @click="submitForm('form')" :loading="flag">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { validatorIndex } from '@/utils/validator'
import API from '@/api'
export default {
  data() {
    return {
      id: '',
      flag: false,
      title: '',
      dialogVisible: false,
      params: {
        sortKey: '',
        uid: '',
        active: false,
      },
      rules: {
        sortKey: [
          { required: true, message: '请输入排序', trigger: 'blur' },
          { validator: validatorIndex, trigger: 'blur' },
        ],
        uid: [
          { required: true, message: '请输入推荐用户id', trigger: 'blur' },
          { validator: validatorIndex, trigger: 'blur' },
        ],

      }
    }
  },
  methods: {
    // 表单验证提交
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.flag = true
          if (this.title === '编辑推送') {
            this.updateRecommendation()
          } else {
            this.addRecommendation()
          }
        } else {
          return
        }
      });
    },
    // 编辑推送
    updateRecommendation() {
      let params = Object.assign({}, this.params, { id: this.id })
      API.updateRecommendation(params).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '编辑成功',
            type: 'success'
          });
          this.$emit('handlerrecommend')
        } else {
          this.$message.error('编辑失败')
        }
        this.handleClose();
        this.flag = false
      }).catch(() => {
        this.handleClose();
        this.flag = false
      })
    },
    // 新增推送
    addRecommendation() {
      API.addRecommendation(this.params).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '新增成功',
            type: 'success'
          });
          this.$emit('handlerrecommend')
        } else {
          this.$message.error('新增失败')
        }
        this.handleClose();
        this.flag = false
      }).catch(() => {
        this.handleClose();
        this.flag = false
      })
    },

    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.$refs.form.resetFields();
      this.params = {
        sortKey: '',
        uid: '',
        active: false,
      }
    },
    open(type,row) {
      this.dialogVisible = true
      if(type === 'edit') {
        this.title = '编辑推送'
        this.id = row.id
        this.params.sortKey = row.sortKey
        this.params.uid = row.uid
        this.params.active = row.active
      } else {
        this.title = '新增推送'
      }
    }
  }
}
</script>
<style scoped>
  .el-input {
    width: 180px;
  }
</style>